import React, { useContext } from "react";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { CircularProgress } from "@mui/material";
import { useSailor } from "./hooks/useSailor";
import { useSailorRiskProfile } from "./hooks/useSailorRiskProfile";

const SailorContext = React.createContext();
const SailorRiskProfileContext = React.createContext();

export function useSailorContext() {
  return useContext(SailorContext);
}
export function useSailorRiskProfileContext() {
  return useContext(SailorRiskProfileContext);
}

export function SailorProvider({ sailorId, children }) {
  const { setError } = useErrorMessage();
  const { sailor, loading, error } = useSailor(sailorId);
  const { sailorRiskProfile, loadingRiskProfile, errorRiskProfile } =
    useSailorRiskProfile({ sailorId });

  if (error || errorRiskProfile) {
    setError(error);
  }

  if (loading || loadingRiskProfile || !sailor) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <SailorContext.Provider value={sailor}>
      <SailorRiskProfileContext.Provider value={sailorRiskProfile}>
        {children}
      </SailorRiskProfileContext.Provider>
    </SailorContext.Provider>
  );
}
